import { Controller, useForm, useFieldArray } from "react-hook-form"
import Modal from "../../UI/Modal/Modal"
import classes from "../AdminForm.module.css"
import CustomButton from "../../UI/CustomButton/CustomButton"
import Input from "../../UI/Form/Input"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import { howItWasApi } from "../../../Api/api"
import { Button } from "@mui/material"

const AddHowItWas = (props) => {
    const { onClose, createHowItWas, setIsFetching } = props

    const { handleSubmit, control } = useForm()

    const { fields, append, remove, move } = useFieldArray({
        control,
        name: "content"
    })

    const onDragEnd = result => {
        if (!result.destination) return
        move(result.source.index, result.destination.index)
    }

    async function uploadFile(file) {
        const res = await howItWasApi.uploadFile(file)
        return res.path
    }

    const onSubmit = async (data) => {
        setIsFetching(true)
        let bgUrl = data.backgroundImg
        if (data.backgroundImg instanceof File) {
            bgUrl = await uploadFile(data.backgroundImg)
        }

        const content = await Promise.all(
            data.content.map(async item => {
                let photoUrl = item.photo
                if (item.photo instanceof File) {
                    photoUrl = await uploadFile(item.photo)
                }
                return {
                    title: item.title,
                    photo: photoUrl || '',
                    youtubeUrl: item.youtubeUrl || ''
                }
            })
        )

        const payload = {
            title: data.title,
            backgroundImg: bgUrl,
            content
        }

        createHowItWas(payload)
        setIsFetching(false)
    }

    return (
        <Modal
            title={"Add new How It Was"}
            onClose={onClose}
        >
            <form
                className={classes.main}
                onSubmit={handleSubmit(onSubmit)}
            >
                <Controller
                    name="title"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Required Field!" }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Input
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Name"
                        />
                    )}
                />
                <Controller
                    name="backgroundImg"
                    control={control}
                    render={({ field }) => (
                        <>
                            <h4>Background Img</h4>
                            <input
                                type="file"
                                accept="image/*"
                                id="bg"
                                hidden
                                onChange={(e) => field.onChange(e.target.files[0])}
                            />
                            <label className={classes.selectPhotoDrag} htmlFor={"bg"}>Select Photo</label>
                            {field.value && !(typeof field.value === "string") && (
                                <img
                                    src={URL.createObjectURL(field.value)}
                                    alt="preview"
                                    width={120}
                                />
                            )}
                        </>
                    )}
                />
                <h4>Content</h4>
                <CustomButton
                    type="button"
                    onClick={() => append({ title: "", photo: null, youtubeUrl: "" })}
                >
                    Add Slide
                </CustomButton>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="content">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={classes.drag}
                            >
                                {fields.map((item, index) => (
                                    <Draggable
                                        key={item.id}
                                        draggableId={item.id}
                                        index={index}
                                    >
                                        {(prov) => (
                                            <div
                                                ref={prov.innerRef}
                                                {...prov.draggableProps}
                                                className={classes.dragItem}
                                                style={{ ...prov.draggableProps.style }}
                                            >
                                                <span
                                                    {...prov.dragHandleProps}
                                                    style={{ cursor: "grab" }}
                                                >
                                                    ☰
                                                </span>
                                                <div className={classes.dragField}>
                                                    <Controller
                                                        name={`content.${index}.title`}
                                                        control={control}
                                                        defaultValue=""
                                                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                            <Input
                                                                onChange={onChange}
                                                                value={value}
                                                                error={error}
                                                                label="Slide title"
                                                            />
                                                        )}
                                                    />
                                                    <Controller
                                                        name={`content.${index}.youtubeUrl`}
                                                        control={control}
                                                        defaultValue=""
                                                        render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                            <Input
                                                                onChange={onChange}
                                                                value={value}
                                                                error={error}
                                                                label="YouTube URL"
                                                            />
                                                        )}
                                                    />
                                                </div>
                                                {/* Загрузка картинки */}
                                                <Controller
                                                    name={`content.${index}.photo`}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <>
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                hidden
                                                                id={index}
                                                                onChange={(e) => field.onChange(e.target.files[0])}
                                                            />
                                                            <label className={classes.selectPhotoDrag} htmlFor={index}>Select Photo</label>
                                                            {field.value && !(typeof field.value === "string") && (
                                                                <img
                                                                    src={URL.createObjectURL(field.value)}
                                                                    alt="preview"
                                                                    className={classes.dragPreview}
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Button
                                                    type="button"
                                                    onClick={() => remove(index)}
                                                    className={classes.removeDragButt}
                                                >
                                                    ×
                                                </Button>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
                <CustomButton type="submit">Create</CustomButton>
            </form>
        </Modal>
    )
}

export default AddHowItWas
